import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { AuthProvider, useAuth } from './src/context/AuthContext';
import LandingScreen from './src/screens/LandingScreen';
import TabNavigator from './src/navigation/TabNavigator';

const Stack = createStackNavigator();

function Navigation() {
    const { session } = useAuth();
    
    console.log('Navigation rendering, session:', session);

    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            {!session ? (
                <Stack.Screen name="Landing" component={LandingScreen} />
            ) : (
                <Stack.Screen name="MainApp" component={TabNavigator} />
            )}
        </Stack.Navigator>
    );
}

const App = () => {
    console.log('App rendering');
    
    return (
        <AuthProvider>
            <NavigationContainer>
                <Navigation />
            </NavigationContainer>
        </AuthProvider>
    );
};

export default App; 